/* ============
 * All Taxes
 * ============
 *
 * All taxes.
 */

import Vue from 'vue';
import store from './../../store';
import taxTransformer from './../../transformers/tax';

const success = ({ data }, resolve) => {
  const taxes = taxTransformer.fetchCollection(data.data);
  store.dispatch('fetchTaxes', { taxes });

  resolve(taxes);
};

const failed = (error, reject) => reject(error);

// Display taxes.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('taxes')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/tax/all.js